import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { trigger, style, animate, transition } from '@angular/animations';
import { SponsorsService } from '../services/sponsors.service';
import { Sponsor } from "../models/Sponsor";

import {
  faSearch
} from "@fortawesome/free-solid-svg-icons";

import {
  faFacebook,
  faPinterest,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import {
  faBars,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'app-landing-page',
  animations: [
    trigger(
      'pageFade', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms', style({ opacity: 0 }))
      ])
    ]
    )
  ],
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
  providers: [SponsorsService]
})

export class LandingPageComponent implements OnInit {
  @Input() handleSearch: Function;

  faFacebook = faFacebook;
  faPinterest = faPinterest;
  faSearch = faSearch;
  faInstagram = faInstagram;
  faYoutube = faYoutube;
  faBars = faBars;
  faTimes = faTimes;

  brandImagePathOld = '/assets/images/WSNLALogo.svg';
  // brandImagePathLogoOnly = '/assets/images/WSNLALogo.svg';
  brandImagePath = '/assets/images/wsnla-logo-new.png';
  brandImagePathLogoOnly = '/assets/images/wsnla-logo-new.png';
  brandImagePathLogoOnlyLeaf = '/assets/images/logo-mini.png';
  barIcon = '/assets/images/bar-icon.svg';
  closeIcon = '/assets/images/close-icon.svg';

  searchModel = '';
  bgNum = 1;
  sponsors: Sponsor[] = [];

  constructor(private sponsorsService: SponsorsService, private router: Router) { }

  ngOnInit() {
    this.bgNum = Math.floor(Math.random() * (1 + 3 - 1)) + 1;

    this.sponsorsService.getSponsorData().subscribe({
      next: (res: Sponsor[]) => {
        this.sponsors = res;
      },
      error: (err) => {
        console.error('Failed to load sponsors:', err);
      }
    });
  }

  searchEnter(data) {
    this.router.navigate(['/nurseries'], { queryParams: { keyword: this.searchModel } });
  }
}
